import React, { useState, useEffect } from "react";
import axios from "../Utility/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Utility/AuthContext";

import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

export default function ChangePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL || "";
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  const handleChangePassword = async () => {
    try {
      await axios.post(
        `${API}/api/change-password`,
        { username: user.username, password: newPassword },
        { withCredentials: true },
      );
      setMessage("Password changed successfully!");

      setIsError(false);
      setTimeout(() => navigate(`/profile/${user.username}`), 1000);
    } catch (err) {
      setIsError(true);
      setMessage(err.response?.data?.error || "Failed to change password");
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "65vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={6} sx={{ p: 4, borderRadius: 3, width: "100%" }}>
        <Typography variant="h5" textAlign="center" fontWeight="bold" mb={3}>
          Change Password
        </Typography>

        {message && (
          <Alert severity={isError ? "error" : "success"} sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        <Box mb={2}>
          <TextField
            fullWidth
            label="New Password"
            type="password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
          />
        </Box>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleChangePassword}
          sx={{ py: 1.2, borderRadius: 2 }}
        >
          Change Password
        </Button>
      </Paper>
    </Container>
  );
}
